import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { employeeGuard } from '@app/core/guards';

export const routes: Routes = [
  {
    path: 'redirect',
    component: MsalRedirectComponent,
  },
  {
    path: 'geen-toegang',
    loadComponent: () => import('@app/home/pages').then((m) => m.GeenToegangsPage),
  },
  {
    path: 'uitgelogd',
    loadComponent: () => import('@app/home/pages').then((m) => m.UitgelogdPage),
  },
  {
    path: '',
    canActivateChild: [MsalGuard],
    children: [
      {
        path: 'home',
        canActivate: [employeeGuard],
        loadChildren: () => import('@app/home/home.routes').then((m) => m.homeRoutes),
      },
      {
        path: 'licenties',
        canActivate: [employeeGuard],
        loadChildren: () => import('@app/licenses/licenses.routes').then((m) => m.licentiesRoutes),
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('@app/home/pages').then((m) => m.NotFoundPage),
  },
];
